export default __webpack_public_path__ + "66d1ff30ead5a20098755a6b60ccde1d.svg";